export const PERIODS = [
  { key: "30d", label: "30 days", previous: "vs previous 30 days", added: "added in the last 30 days" },
  { key: "quarter", label: "Quarter", previous: "vs same point last quarter", added: "added this quarter" },
  { key: "year", label: "Year", previous: "vs previous year", added: "added this year" },
];

export const DEFAULT_PERIOD = "year";

export const periodByKey = (key) =>
  PERIODS.find((p) => p.key === key) || PERIODS.find((p) => p.key === DEFAULT_PERIOD);

export const KPI_COLORS = {
  projects: "#C95EBE",
  documents: "#8B55DD",
  proposals: "#89B70D",
  kb: "#4D84F2",
};

export const CHART_COLORS = {
  projects: "#8B55DD",
  proposals: "#C95EBE",
};

export const DEADLINE_COLORS = {
  passed: "#E21919",
  soon: "#CCA300",
  later: "#008923",
};

const CLOSED_STATUSES = new Set(["Submitted", "Won", "Win", "Lost", "Missed", "Chose Not to Apply"]);
export const isOpenProject = (project) => !CLOSED_STATUSES.has(project?.status);

export const formatNumber = (value) => (value ?? 0).toLocaleString();

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

// Deadlines are plain dates ("2026-10-08"), so they are read as local dates, not UTC midnight.
export const parseDeadline = (value) => {
  if (!value || value === "_") return null;
  const [y, m, d] = String(value).slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

export const daysUntil = (date, today = new Date()) =>
  Math.round((startOfDay(date) - startOfDay(today)) / 86400000);

export const deadlineTone = (days) => (days < 0 ? "passed" : days < 7 ? "soon" : "later");

export const relativeDeadline = (days) => {
  if (days === 0) return "Due today";
  if (days === 1) return "Due tomorrow";
  if (days > 1) return `Due in ${days} days`;
  if (days === -1) return "Passed yesterday";
  return `Passed ${Math.abs(days)} days ago`;
};

// Change chip for a count KPI: tone drives the colour, text is what the chip says.
export const percentChip = (change, current) => {
  if (change === null || change === undefined) {
    return current > 0 ? { text: "New", tone: "up" } : { text: "No change", tone: "flat" };
  }
  if (change === 0) return { text: "No change", tone: "flat" };
  return { text: `${change > 0 ? "+" : "-"}${Math.abs(change)}%`, tone: change > 0 ? "up" : "down" };
};

export const smoothPath = (points) =>
  points.reduce((d, [x, y], i, all) => {
    if (i === 0) return `M${x},${y}`;
    const [px, py] = all[i - 1];
    const mx = (px + x) / 2;
    return `${d} C${mx},${py} ${mx},${y} ${x},${y}`;
  }, "");

export const projectPath = (project) =>
  project.org_id
    ? `/rfp-projects/project/${project.id}/org/${project.org_id}/project-overview`
    : `/rfp-projects/project/${project.id}/project-overview`;

const PERIOD_STORAGE_KEY = "rfp_dashboard_period";

export const readStoredPeriod = () => {
  try {
    return periodByKey(localStorage.getItem(PERIOD_STORAGE_KEY)).key;
  } catch {
    return DEFAULT_PERIOD;
  }
};

export const storePeriod = (key) => {
  try {
    localStorage.setItem(PERIOD_STORAGE_KEY, key);
  } catch {
    // Storage can be unavailable in private windows; the toggle still works for this visit.
  }
};
